import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  script: "",
};

export const scriptSlice = createSlice({
  name: "script",
  initialState,
  reducers: {
    generateScript: (state, action) => {
      state.script = action.payload;
    },
    copyToClipBoard: (state, action) => {
      navigator.clipboard.writeText(action.payload);
    },
  },
});

export const { generateScript, copyToClipBoard } = scriptSlice.actions;

export default scriptSlice.reducer;
